import { gscSendUserParams } from "@/utils/gsc_send_user_params";
import { yaReachGoal } from "@/utils/ya_reach_goal";

export const metrikaCombinedGoal = (
  ...params: Parameters<typeof yaReachGoal>
) => {
  const event = params[0];

  yaReachGoal(...params);

  gscSendUserParams({
    [event]: true,
  });
};
